import React, { useState, useEffect } from 'react'
import {Table } from '@mui/material'
import ResultsTable from './ResultsTable'
import { useParams } from 'react-router-dom'

export default function Results({results, selectedEvent}) {

    const {prov, year} = useParams()

    return (
        <div id="scroll" className={'classes.root overflow-y-auto'}>
            {results && 
            results.contests.sort((a, b) => {
                if (a.office.name === "Mayor"){return -1}
                if (b.office.name === "Mayor"){return 1}
                else {return a.area.name.localeCompare(b.area.name, undefined, { numeric: true, sensitivity: 'base' })}
            })
            .filter(contest=> {
                if (selectedEvent) {
                    return contest.id === selectedEvent
                } else return true
            })
            .map(contest=>{
                let eventString = `${contest.area.name} - ${contest.office.name}`
                    if (year === '2023' && prov === 'on') {
                        
                        eventString = `${contest.area.name}`
                    }
                return (
                    <div className={'classes.officeContainer '}>
                        <div className={'classes.titleRow flex gap-2 relative items-center'}>
                            <div className="text-white p-1 sm:p-3 font-bold tracking-wide bg-gRed uppercase">{eventString}</div>
                            <div className="polls p-1 sm:p-3 grow" >{contest.polls.reported} out of {contest.polls.total} polls reporting</div>
                        </div>
                        {contest.positions > 1 && <div id="positions">{contest.positions} positions available</div>}
                        <ResultsTable results={contest}/>
                    </div>
                )
            })}
        </div>
    )
}
